import { LocalStorageService } from "@hcworkspace/sysque/toolbelt/utils";
import { ImportScheduleReturnCodes } from "../models/import-schedule-return-codes";

export class ImportScheduleReceiveController{
    constructor(private localStorageService: LocalStorageService) {}

    public ApplyImportScheduleResult(resultCode: ImportScheduleReturnCodes): void {    
        this.localStorageService.updateDispatchLocalStorage('importScheduleResult', JSON.stringify(resultCode));
    }
}